import React from 'react';
import JsxParser from 'react-jsx-parser';
import { AnalyticsProvider, AnalyticsTrigger, Anchor, Button, Card, CardContent, Grid, GridColumn, HeaderMegamenuBanner, Icon, Image, Tag, Text } from 'telia-front-react';
const HeaderJsxParser = (props) => {
    return (React.createElement(JsxParser, { jsx: props.content, components: { AnalyticsProvider, AnalyticsTrigger, Anchor, Button, Card, CardContent, Grid, GridColumn, HeaderMegamenuBanner, Icon, Image, Tag, Text } }));
};
export default HeaderJsxParser;
//# sourceMappingURL=HeaderJsxParser.js.map